import imageSpecsTpl from '../templates/image_specs.directive.html';

export default function imageSpecs() {
  return {
    restrict: 'E',
    template: imageSpecsTpl,
    scope: {
      creative: '='
    }
  };
}
